import type { ChangelogFormatter } from '../types';
import { createChangeProcessors } from './changeProcessors';
import { executePredicatedProcessors } from '../../lib/predicatedProcessor';
import createTestingSuiteBuffer from './testingSuiteBuffer';
import type { TSuiteBufferResult } from './types';
import { filterUnsupportedChanges } from './helpers';
import createTemplates from './templates';


// todo - BUILD 1598 - use a different type for this that doesn't couple with the buffer internals
const testingSuiteFormatter: ChangelogFormatter<TSuiteBufferResult> = ({
  A,
  B,
  changesByActionPublicId,
  featureFlags,
}) => {
  const processingBuffer = createTestingSuiteBuffer();
  const templates = createTemplates({ featureFlags });

  const changeProcessors = createChangeProcessors({
    A,
    B,
    entriesBuffer: processingBuffer,
    templates,
  });

  /**
    * Filter out unsupported Changes for the Testing Suite formatter.
    * This process removes unsupported Changes and keeps only those that this formatter can handle.
    * The benefit of doing this prior to the execution is that the processing code needs to
    * only to handle the relevant changes
    */
  const supportedChanges = filterUnsupportedChanges(Object.values(changesByActionPublicId).flat());
  executePredicatedProcessors({
    items: supportedChanges,
    processorRegistry: changeProcessors,
  });

  return processingBuffer.package();
};


export default testingSuiteFormatter;
